export const UPDATE_ALL_COUPONS = 'coupons/UPDATE_ALL_COUPONS'
export const UPDATE_COMPANY_COUPONS = 'coupons/UPDATE_COMPANY_COUPONS'
export const UPDATE_COUPON = 'coupons/UPDATE_COUPON'
export const UPDATE_COUPON_AMOUNT = 'coupons/UPDATE_COUPON_AMOUNT'
export const UPDATE_COUPON_SCHEDULES = 'coupons/UPDATE_COUPON_SCHEDULES'
export const IS_LOADING = 'coupons/IS_LOADING'
